import React from "react";
import getCodedValue from "../../utils/getCodedValue";

const MaritalStatus = ({ data, summary: isSummary }) => {
  if (isSummary) {
    return <div> Marital Status: {getCodedValue(data)}</div>;
  }
  return (
    <div>
      <h4>Marital Status</h4>
      <div>{getCodedValue(data)}</div>
    </div>
  );
};

export default MaritalStatus;
